import { jsx as _jsx } from "react/jsx-runtime";
import { Loader } from "@sundae/ui-toolkit";
export const LoadingState = ({ size = "medium" }) => (_jsx("div", { className: "flex h-full items-center justify-center p-8", children: _jsx(Loader, { size: size }) }));
export default LoadingState;
//# sourceMappingURL=LoadingState.js.map